import { useQuery } from '@apollo/client';
import { GET_SITE_CREDITS_QUERY } from './siteCredits.rest';

export const useSiteCredits = () => useQuery(GET_SITE_CREDITS_QUERY);
